import { NodoEstructuraJerarquica } from './nodo-estructura-jerarquica.model';
import { EstructuraJerarquica } from './estructura-jerarquica.model';
import { TipoEvaluacion } from './tipo-evaluacion.model';
import { Escenario } from './escenario.model';
import { Usuario } from './usuario.model';
import { Objetivo } from './objetivo.model';
import { DimensionRiesgo} from './dimension-riesgo.model';
import { ObjetivoRiesgo} from './objetivo-riesgo.model';
import { FactorPonderacion} from './factor-ponderacion.model';
import { Evaluacion } from './evaluacion.model';
import { PonderacionEvaluacion} from './ponderacion-evaluacion.model';
import { PonderacionObjetivo} from './ponderacion-objetivo.model';


export class Consolidacion
{
    id: number;
    nombre: string;
    version: number;
    tipo: string;
    estructuraJerarquica: EstructuraJerarquica;
    nodoEstructuraJerarquica: NodoEstructuraJerarquica;
    responsable: Usuario;
    creador :Usuario;
    fechaCreado: Date;
    fechaInicio: Date;
    fechaFin: Date;
    objetivos: Objetivo[];
    usuarios: Usuario[];
    dimensiones: DimensionRiesgo[];
    riesgos: ObjetivoRiesgo[];
    factorPonderacion: FactorPonderacion;
    evaluaciones: Evaluacion [];
    escenario: Escenario;
    /*formulaDeExposicion: string;
    apetito: number;
    tolerancia: number;*/
    ponderacionesPorEvaluacion: PonderacionEvaluacion[];
    ponderacionesPorObjetivo: PonderacionObjetivo[];
    /**
     * Constructor
     *
     * @param evaluacion
     */
    constructor(evaluacion)
    {
        {
            this.id = evaluacion.id || null;
            this.nombre = evaluacion.nombre || '';
            this.version= evaluacion.version || 0;
            this.tipo = evaluacion.tipo || null;
            this.estructuraJerarquica = evaluacion.estructuraJerarquica || null;
            this.nodoEstructuraJerarquica= evaluacion.nodoEstructuraJerarquica || null;
            this.responsable = evaluacion.responsable || null;
            this.creador= evaluacion.creador || null;
            this.fechaCreado= evaluacion.fechaCreado || new Date();
            this.fechaInicio =evaluacion.fechaInicio || null;
            this.fechaFin = evaluacion.fechaFin || null;
            this.objetivos = evaluacion.objetivos || [];
            this.usuarios = evaluacion.usuarios || [];
            this.dimensiones = evaluacion.dimensiones || [];
            this.riesgos = evaluacion.riesgos || [];
            this.factorPonderacion = evaluacion.factorPonderacion || null;
            this.evaluaciones = evaluacion.evaluaciones || [];
            /*this.formulaDeExposicion=  evaluacion.formulaDeExposicion || "";
            this.apetito= evaluacion.apetito || 0;
            this.tolerancia= evaluacion.tolerancia || 0;*/
            this.escenario= evaluacion.escenario;
            this.ponderacionesPorEvaluacion = evaluacion.ponderacionesPorEvaluacion || [];
            this.ponderacionesPorObjetivo= evaluacion.ponderacionesPorObjetivo || [];

        }
    }
}
